import * as React from 'react'
import {Provider} from 'react-redux'

import styles from 'airship/components/HelpMenu/styles.module.css'
import Popover from 'airship/components/Popover'

import SvgSprite from 'airship/patterns/svg-sprite'
import showInProductRecruitingModal from 'airship/modules/product-research'
import ContactSupportModal from 'airship/components/InProductSupport/index'
import store from 'airship/components/InProductSupport/store'

const HelpMenu: React.FunctionComponent = () => {
  const [popoverIsOpen, setPopoverIsOpen] = React.useState(false)
  const [feedbackModalIsOpen, setFeedbackModalIsOpen] = React.useState(false)
  const [openSupportModal, setOpenSupportModal] = React.useState(false)
  const targetElement = (
    <li className={styles.navigationItem}>
      <a
        onClick={() => setPopoverIsOpen(!popoverIsOpen)}
        data-testid="help-menu-popover"
      >
        <SvgSprite name="help-fill" displayClasses={styles.icon} />
      </a>
    </li>
  )

  return (
    <>
      <Popover
        displayClasses={styles.popoverBody}
        isOpen={popoverIsOpen}
        onClose={() => setPopoverIsOpen(false)}
        targetElement={targetElement}
      >
        <ul className={styles.menu}>
          <li className={styles.menuItem}>
            <a
              className={styles.label}
              onClick={() =>
                window.open('https://docs.airship.com/whats-new/', '_blank')
              }
            >
              See what&apos;s new
            </a>
          </li>
          <li className={styles.menuItem}>
            <a
              className={styles.label}
              onClick={() => window.open('https://docs.airship.com/', '_blank')}
            >
              Read the docs
            </a>
          </li>
        </ul>
        <hr className={styles.divider} />
        <ul className={styles.menu}>
          <li className={styles.menuItem}>
            <a
              className={styles.label}
              onClick={() => {
                if (!feedbackModalIsOpen) {
                  showInProductRecruitingModal({
                    setModalIsOpen: setFeedbackModalIsOpen,
                  })
                  setFeedbackModalIsOpen(true)
                }
              }}
              data-testid="in-product-recruiting-modal"
            >
              Share feedback
            </a>
          </li>
          <li className={styles.menuItem}>
            <a
              className={styles.label}
              onClick={() => setOpenSupportModal(true)}
            >
              Get support
            </a>
          </li>
        </ul>
      </Popover>
      <Provider store={store}>
        <ContactSupportModal
          isOpen={openSupportModal}
          onClose={() => setOpenSupportModal(false)}
        />
      </Provider>
    </>
  )
}

export default HelpMenu
